export function inactivityListener (callback, time) {
  let timer = setTimeout(callback, time);
  function resetTimer() {
    clearTimeout(timer);
    timer = setTimeout(callback, time);
  }
  document.addEventListener('keypress', resetTimer);
  document.addEventListener('mousemove', resetTimer);
  document.addEventListener('touchmove', resetTimer);
  document.addEventListener('touchstart', resetTimer);
  document.addEventListener('scroll', resetTimer, true);
  return () => {
    document.removeEventListener('keypress', resetTimer);
    document.removeEventListener('mousemove', resetTimer);
    document.removeEventListener('touchmove', resetTimer);
    document.removeEventListener('touchstart', resetTimer);
    document.removeEventListener('scroll', resetTimer, true);
    clearTimeout(timer);
  }
}